import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Dashboard from './views/Dashboard';
import Base from './ui/Base';
import Ajustes from './views/Ajustes';
import { initInterceptor } from './util/interceptor';
import Login from './views/Login';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Base />,
        children: [
          {
            index: true,
            element: <Dashboard />
          },
          {
            path: 'dashboard',
            element: <Dashboard />
          },
          {
            path: 'ajustes',
            element: <Ajustes />
          },
        ]
      },
      {
        path: 'login',
        element: <Login />
      },
    ]
  },
]);

initInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <RouterProvider router={router} />
  // </React.StrictMode>
);
